<template>
  <div>
    <div v-for="job in jobs">
      <a @click="selectJob(job)"><strong>{{ job.title }}</strong></a>
      <div>
        {{ job.short }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'JobsList',
    props: ['jobs'],
    data () {
      return {}
    },
    computed: {},
    methods: {
      selectJob (job) {
        this.$emit('selectJob', job)
      }
    }
  }
</script>